import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import ActionCreator from "../ActionCreator";
import * as Widget from "./Widget2";

class AboutUsSection extends Component {
  render() {
    let { navActions } = this.props;

    return (
      <Wrapper>
        <Widget.SectionTitle haveMarginBottom={true}>
          最懂你的咖啡平台
        </Widget.SectionTitle>
        <Widget.SectionLine />
        <Widget.SectionContainer>
          <Widget.Row css="margin-bottom: 15px;">
            <IconImage
              src={"/images/pages/products/icon04.png"}
              css="margin-right: 20px;"
            />
            <IconImage
              src={"/images/pages/products/icon05.png"}
              css="margin-right: 20px;"
            />
            <IconImage src={"/images/pages/products/icon06.png"} />
          </Widget.Row>
          <div className="text">
            {
              "咖啡不只是用來提神的飲品，而是個人品味的延伸。\n好咖嚴選的每一間店家都有著對咖啡的堅持與熱情，\n請讓我們陪伴您一起發現咖啡之美，使享受美好成為您生活隨手可得的習慣。"
            }
          </div>
          <Widget.BrownButton onClick={() => navActions.push("/about")}>
            關於我們
          </Widget.BrownButton>
        </Widget.SectionContainer>
        <Widget.SectionLine />
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
`;

const IconImage = styled.img`
  width: 60px;
  height: 60px;

  @media screen and (max-width: 600px) {
    width: 40px;
    height: 40px;
  }

  ${props => props.css || ""};
`;

export default connect(
  null,
  ActionCreator
)(AboutUsSection);
